import React from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';

import * as d3 from 'd3';
import _ from 'lodash';
import color from '../../styles/color';

const BarChart = (props) => {
  const { dataset } = props;
  const barRef = useRef(null);

  useEffect(() => {
    if (!barRef) return;
    const $container = d3.select(barRef.current),
      $gBar = $container.select('g.bar'),
      $gAxis = $container.select('g.axis'),
      $gAxisX = $gAxis.select('g.x'),
      $gAxisY = $gAxis.select('g.y');

    let w, h;
    _updateDimension();

    const margin = {
      top: 10,
      left: 50,
      right: 10,
      bottom: 10,
    };

    render();

    function render() {
      const Y = d3
        .scaleBand()
        .domain(dataset.map((d) => d.phase))
        .range([margin.top, h - margin.bottom])
        .paddingInner(0.25)
        .paddingOuter(0.25);

      const X = d3
        .scaleLinear()
        .domain([0, 50000])
        .range([margin.left, w - margin.right - margin.left]);

      $gAxisX.call(d3.axisBottom(X).tickValues([25000, 50000]));
      $gAxisX.attr('transform', `translate(0, ${h - margin.bottom})`);

      $gAxisY.call(d3.axisLeft(Y));
      $gAxisY.attr('transform', `translate(${margin.left}, 0)`);

      const $bar = $gBar
        .selectAll('rect.bar')
        .data(dataset)
        .join('rect');
      $bar
        .attr('class', 'bar')
        .attr('y', (d) => Y(d.phase))
        .attr('height', Y.bandwidth())
        .attr('x', X(0))
        .attr('width', (d) => X(d.plasticuse) - X(0))
        .attr('fill', color.th);
    }
    function _updateDimension() {
      const parent = barRef.current.parentElement;

      w = parent.offsetWidth;
      h = 100;
    }

    function resize() {
      _updateDimension();
      render();
    }

    window.addEventListener('resize', _.debounce(resize, 250));
  }, [barRef]);
  return (
    <div>
      <svg ref={barRef} height={150} width="100%">
        <g className="axis">
          <g className="x"></g>
          <g className="y"></g>
        </g>
        <g className="bar"></g>
      </svg>
    </div>
  );
};

export default BarChart;
